module.exports = __webpack_public_path__ + "img/ic_user_active.9734c66a.svg";